module.exports = __webpack_public_path__ + "static/media/tutorial_banner.6795b71a.jpg";